"use client";

import { cva, type VariantProps } from "class-variance-authority";
import { type PropsWithChildren, type Ref } from "react";

import { cn } from "../../utils/cn.util";

export const stickyWrapperVariants = cva("sticky z-50", {
  variants: {
    type: {
      top: "top-0",
      bottom: "bottom-0",
      left: "left-0",
      right: "right-0",
    },
  },
  defaultVariants: {
    type: "top",
  },
});

export type StickyWrapperProps = PropsWithChildren &
  VariantProps<typeof stickyWrapperVariants> & {
    className?: string;
    ref?: Ref<HTMLDivElement>;
  };

export const StickyWrapper = ({ children, className, type, ref }: StickyWrapperProps) => {
  return (
    <div className={cn(stickyWrapperVariants({ type }), "sticky-wrapper", className)} ref={ref}>
      {children}
    </div>
  );
};
